import { withTranslation } from "react-i18next";
import Images from './Images';

export default withTranslation()(Images);